var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.376,
    height: 12.301,
    viewBox: "0 0 11.376 12.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58473",
    "data-name": "Group 58473",
    transform: "translate(-18.85 -151.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Delete",
    "data-name": "Iconly/Light-Outline/Delete",
    transform: "translate(16 150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M4.268-.15h2.54A1.37,1.37,0,0,1,8.13.865l0,.009.152.757a.39.39,0,0,0,.374.313h1.967a.6.6,0,0,1,0,1.2H.45a.6.6,0,1,1,0-1.2H2.414l.051,0a.389.389,0,0,0,.327-.309L2.939.893A1.369,1.369,0,0,1,4.268-.15Zm2.7,1.294a.17.17,0,0,0-.156-.094H4.268a.167.167,0,0,0-.161.12l-.139.7q-.008.039-.017.077H7.125q-.01-.038-.017-.077ZM9.815,3.882h.028a.6.6,0,0,1,.55.646l-.005.063c-.1,1.24-.354,4.277-.511,5.7a1.926,1.926,0,0,1-2,1.839c-.843.015-1.605.022-2.329.022-.788,0-1.571-.008-2.393-.025A1.922,1.922,0,0,1,1.2,10.295C1.01,8.6.685,4.562.682,4.528a.6.6,0,0,1,.55-.646h.026a.608.608,0,0,1,.621.55c0,.011.133,1.656.278,3.288l.029.324c.083.926.152,1.639.206,2.118a.735.735,0,0,0,.789.763c.793.017,1.573.025,2.383.025.74,0,1.511-.007,2.292-.021a.75.75,0,0,0,.829-.771c.156-1.407.407-4.429.508-5.663L9.2,4.431A.606.606,0,0,1,9.815,3.882Z",
    transform: "translate(0 0)",
    fill: "#f55"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_42287",
    "data-name": "Path 42287",
    d: "M.631,0a.577.577,0,0,1,.631.5v3A.577.577,0,0,1,.631,4,.577.577,0,0,1,0,3.5V.5A.577.577,0,0,1,.631,0Z",
    transform: "translate(23.869 157)",
    fill: "#f55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8bc1ab38dfecb9b5af9cf31d82b982f3.svg";
export { ForwardRef as ReactComponent };